import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {
  activeAdminTenantId,
  canWriteTenant,
  useAuth,
} from '../../auth/AuthContext';
import { DataIntegrity } from '../admin/DataIntegrity';

/**
 * Data integrity for the signed-in tenant.
 *
 * The same panel platform admins use under Operations, scanned for one
 * tenant. It replaced a six-hourly email that re-sent the same backlog
 * whenever anything was outstanding — a report is only useful when someone
 * is looking at it, and one that arrives whether or not anything changed is
 * one people learn to delete unread.
 *
 * Read-only by design. The Re-score action behind the platform view is a
 * superadmin endpoint, so the tenant panel shows the finding and who to ask
 * rather than a button that would 403 — which would report recovery that
 * never happened, the exact confusion this surface exists to remove.
 */
export function TenantDataIntegrity() {
  const { user } = useAuth();
  const tenantId = activeAdminTenantId(user);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Data integrity
      </Typography>
      {tenantId ? (
        <DataIntegrity
          embedded
          tenantId={tenantId}
          // Disabling a capture is an operational write: a coordinator may,
          // a read-only tenant_admin may not. Mirrors the server's
          // require_tenant_operator_write so the button matches the answer.
          allowDisable={canWriteTenant(user, tenantId)}
        />
      ) : (
        // Reachable if a staff membership is suspended between login and
        // navigation. Saying so beats rendering an empty report, which
        // would read as "nothing is wrong".
        <Alert severity="info">
          No active tenant for this account — nothing to report on.
        </Alert>
      )}
    </Box>
  );
}
